import {
    FormControl,
    FormControlLabel,
    FormGroup,
    Checkbox,
    Typography,
    Box,
} from '@mui/material';
import { FormikProps } from 'formik';
import { ChannelsWebSurvey } from '../../../../../shared/types/modules/channels-web-information';
import { Question } from './props';

export const RenderQuestion = ({
    question,
    formik,
}: {
    question: Question;
    formik: FormikProps<ChannelsWebSurvey>;
}) => {
    // Ensure that it is always an array of strings
    const selectedValues: string[] = Array.isArray(
        formik.values[question.id as keyof ChannelsWebSurvey]
    )
        ? (formik.values[question.id as keyof ChannelsWebSurvey] as string[])
        : [];

    // Function to manage the selection of up to 4 elements
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        let newValues: string[] = [...selectedValues];

        if (newValues.includes(value)) {
            newValues = newValues.filter((item) => item !== value);
        } else if (newValues.length < 4) {
            newValues.push(value);
        }

        formik.setFieldValue(question.id as keyof ChannelsWebSurvey, newValues);
    };

    return (
        <FormControl fullWidth>
            <FormGroup sx={{ display: 'flex', flexDirection: 'column' }}>
                {(question.options || []).map(
                    (option: string, index: number) => (
                        <FormControlLabel
                            key={index}
                            control={
                                <Checkbox
                                    checked={selectedValues.includes(option)}
                                    onChange={handleChange}
                                    value={option}
                                />
                            }
                            label={
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    fontWeight="bold"
                                    sx={{ color: 'primary.main' }}
                                >
                                    {option}
                                </Typography>
                            }
                            sx={{ marginBottom: '4px' }}
                        />
                    )
                )}
            </FormGroup>
            {formik.errors[question.id] && formik.touched[question.id] && (
                <Box
                    sx={{
                        color: '#d32f2f',
                        fontSize: '0.75rem',
                        marginTop: '8px',
                    }}
                >
                    {formik.errors[question.id]}
                </Box>
            )}
        </FormControl>
    );
};
